<section class="hvac-product-details-content-section hvac-product-content-section-options" *ngIf="showOptions$ | async">
    <div class="hvac-product-content-section-overview">
        <div class="hvac-product-content-section-overview-description">
            <h2 class="hvac-section-heading" [attr.id]="'PRODUCTS.OPTIONS' | translate" tabindex="-1">{{ 'PRODUCTS.OPTIONS' | translate }}</h2>
            <div class="hvac-product-content-section-text" [innerHTML]="optionsTexts$ | async"></div>
        </div>
    </div>
    <hr class="hvac-section-rule">
</section>
